
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import { joinPublicity } from "@/api/index";


@Options({
  components: {}
})
export default class Recruit extends Vue {
  isJoin: boolean = false
  mounted() {
    this.getNativeData();
    (window as any).$eventBus.addListener('receiveAndroidMsg', this.receiveAndroid);
  }
  // 加入
  joinPublicity() {
    if (this.isJoin) {
      return
    }
    this.isJoin = true
    joinPublicity().then((res) => {
      this.isJoin = false
      if (res.data.code !== 0) {
        let errTxt = res.data.code === 100701? res.data.message: '当前申请人数过多，正在排队中，请稍后申请'
        this.$dialog.alert({
          message: errTxt,
          confirmButtonText: '我知道了'
        })
        return
      }
      this.$dialog.alert({
        message: '恭喜您已成功加入拍批内测，如果遇到什么问题可以通过在线客服或者拍批的错误反馈给我们提供宝贵意见~',
        confirmButtonText: '我知道了'
      })
    }).catch((err) => {
      this.$dialog.alert({
        message: '当前申请人数过多，正在排队中，请稍后申请',
        confirmButtonText: '我知道了'
      })
      console.log(err, '加入内测失败')
      this.isJoin = false
    })
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 安卓监听消息
  receiveAndroid(res) {
    console.log('收到传递过来的安卓消息=====> ', typeof res)
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') {
      this.detailNativeData(androidResult.dataJson)
    }
  }
  // 处理端上数据
  detailNativeData(res) {
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
  }
}
